import { APPROVE_SUCCESS_STORY_SUCCESS, CREATE_SUCCESS_STORY, CREATE_SUCCESS_STORY_FAILURE, CREATE_SUCCESS_STORY_SUCCESS, EMPTY_FETCH_SUCCESS_STORY_WITHOUT_PAGINATION, FETCH_ALL_SUCCESS_STORY, FETCH_ALL_SUCCESS_STORY_FAILURE, FETCH_ALL_SUCCESS_STORY_SUCCESS, FETCH_SUCCESS_STORY_BY_ID_SUCCESS, FETCH_SUCCESS_STORY_WITHOUT_PAGINATION_SUCCESS, FETCH_TOTAL_SUCCESS_STORY, FETCH_TOTAL_SUCCESS_STORY_FAILURE, FETCH_TOTAL_SUCCESS_STORY_SUCCESS, RESTORE_STORY_INITIAL, UPDATE_SUCCESS_STORY_SUCCESS } from "../ActionTypes";
  
  const INIT_STATE = {
    successStoryData:[],
    tablePaginationData:{},
    isLoading:true,
    storyCreated:false,
    storyIsCreating:false,
    storyUpdated:false,
    loadingUpdated:true,
    successStoryDataNoPagination:[],
    isFetched:false,
    totalStoryDetails:{},
    loadingTotal:true,
    storyDetailsbyId:{},
    storyApproved:false,
    loadingApproval:true,
  };
  
  function reducers(state = INIT_STATE, action) {
    switch (action.type) {
        case FETCH_ALL_SUCCESS_STORY: {
            return {
              ...state,
              successStoryData: [],
              tablePaginationData: {},
              isLoading:true,
            };
        }
      case FETCH_ALL_SUCCESS_STORY_SUCCESS: {
        return {
          ...state,
          successStoryData: action.payload.data,
          tablePaginationData: action.payload.meta,
          isLoading:false,
        };
      }
      case FETCH_ALL_SUCCESS_STORY_FAILURE: {
        return {
          ...state,
          successStoryData: [],
          tablePaginationData: {},
          isLoading:false,
        };
      }
      case CREATE_SUCCESS_STORY: {
        return {
          ...state,
          storyCreated: false,
          storyIsCreating:true,
        };
      }
      case CREATE_SUCCESS_STORY_SUCCESS: {
          return {
            ...state,
            storyCreated: true,
            storyIsCreating:false,
          };
        }
        case CREATE_SUCCESS_STORY_FAILURE: {
          return {
            ...state,
            storyCreated: false,
            storyIsCreating:false,
          };
        }  
      case RESTORE_STORY_INITIAL:{
          return{
              ...state,
              storyCreated:false,
              storyUpdated:false,
              loadingUpdated:true,
              isFetched:false,
              storyDetailsbyId:{},
              storyApproved:false,
              loadingApproval:true,
          }
      }
      case UPDATE_SUCCESS_STORY_SUCCESS:{
        return{
          ...state,
          storyUpdated:true,
          loadingUpdated:false,
  
        }
      }
      case APPROVE_SUCCESS_STORY_SUCCESS:{
        return{
          ...state,
          storyApproved:true,
    loadingApproval:false,
  
        }
      }
      case FETCH_SUCCESS_STORY_WITHOUT_PAGINATION_SUCCESS:{
        return{
          ...state,
          successStoryDataNoPagination: action.payload.data,
          isFetched:true,
        }
      }
      case EMPTY_FETCH_SUCCESS_STORY_WITHOUT_PAGINATION:{
        return{
          ...state,
          successStoryDataNoPagination: [],
        }
      }
      case FETCH_TOTAL_SUCCESS_STORY:{
        return{
          ...state,
          totalStoryDetails: {},
          loadingTotal: true
        }
      }
      case FETCH_TOTAL_SUCCESS_STORY_SUCCESS:{
        return{
          ...state,
          totalStoryDetails: action.payload,
          loadingTotal: false
        }
      }
      case FETCH_TOTAL_SUCCESS_STORY_FAILURE:{
        return{
          ...state,
          totalStoryDetails: {},
          loadingTotal: false
        }
      }
      case FETCH_SUCCESS_STORY_BY_ID_SUCCESS:{
        return{
          ...state,
          storyDetailsbyId: action.payload,
        }
      }
  
      default:
        return state;
    }
  }
  
  export default reducers;
  